var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UserType } from "healthex-common/user.dtos";
import { autorun, computed, observable } from "mobx";
import { Disposer } from "../Infra/Disposer";
import { NamedRoutes } from "./NamedRoutes";
import { findMatchingNamedRouteParent } from "./RoutingUIManager";
import { SimpleDialogModel } from "./SimpleDialogModel";
export class AppViewModel {
    constructor(container) {
        this.acceptInviteDialog = new SimpleDialogModel();
        this.inviteAcceptedDialog = new SimpleDialogModel();
        this.commonDialog = new SimpleDialogModel();
        this.commonDialogInfo = null;
        this.authManager = container.authManager;
        this.appUIManager = container.appUIManager;
        this.routingUIManager = container.routingUIManager;
        this.acceptInviteManager = container.acceptInviteManager;
        this.loginUIManager = container.loginUIManager;
        this.bannerUIManager = container.bannerUIManager;
        this.deviceManager = container.deviceManager;
        this.organizationsManager = container.organizationsManager;
        this.dialogUIManager = container.dialogUIManager;
        this.ftuEducationDialog = this.appUIManager.ftuEducationDialog;
        this.patientConsentUIManager = container.patientConsentUIManager;
        this.disposer = new Disposer();
        autorun(async () => {
            console.log("Does it need to Accept invite now", this.needsAcceptInvite);
            if (this.needsAcceptInvite) {
                console.log("Needs to Accept invite now");
                await this.acceptInvite();
            }
        });
    }
    run() {
        this.disposer.reaction(() => this.dialogUIManager.dialogInfo, async () => {
            this.handleCommonDialogChange();
        }, { fireImmediately: true, name: "commonDialog" });
    }
    stop() {
        this.disposer.dispose();
    }
    get isHealthcareOrg() {
        return this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION;
    }
    get ftuEducationDialogDescription() {
        return this.authManager.isDataUser
            ? "HealthEx helps your organization securely manage patient data initiatives, from collecting consent to accessing health records. Set up projects, engage patients, and streamline data access for care, research, and more."
            : "HealthEx streamlines patient outreach, enabling data access and patient participation in research, discovery, quality improvement and clinical improvement activities, prioritizing patient transparency, trust, and privacy.";
    }
    get orgName() {
        return this.authManager.orgName;
    }
    get isMobilePortraitTouchDevice() {
        return this.deviceManager.isMobilePortraitTouchDevice;
    }
    get showDesktopNotEnoughSpaceView() {
        return this.isMobilePortraitTouchDevice || this.deviceManager.isMobileNotTouchDevice;
    }
    get desktopNotEnoughSpaceTitle() {
        return this.isMobilePortraitTouchDevice
            ? "There's too much to show on your screen.\nPlease rotate your device."
            : "There's too much to show on your screen.\nPlease increase the size of your browser window.";
    }
    get desktopNotEnoughSpaceText() {
        return this.isMobilePortraitTouchDevice
            ? "For the best experience, we recommend using a laptop or desktop computer. This app may not display properly on smaller screens."
            : "For the best experience, we recommend making your browser fullscreen. This app may not display properly on smaller windows.";
    }
    get banner() {
        return this.bannerUIManager.banner;
    }
    get needsAcceptInvite() {
        return false;
    }
    async acceptInvite() {
        console.warn(`Accept invite flow has been disabled`);
    }
    get showHeaderAndFooter() {
        return (!(this.routingUIManager.currentRoute && this.loginUIManager.isUnauthenticatedRoute(this.routingUIManager.currentRoute)) ||
            this.loginUIManager.isUnauthenticatedHeaderRoute(this.routingUIManager.currentRoute));
    }
    get currentPage() {
        return this.appUIManager.currentPage;
    }
    get isHeaderAndFooterFixedRoute() {
        if (this.patientConsentUIManager.isScreenshotMode)
            return false;
        if (findMatchingNamedRouteParent(this.routingUIManager.currentRoute, [
            NamedRoutes.LOGIN_SELECT,
            NamedRoutes.LOGIN_AS_ORG_USER,
            NamedRoutes.LOGIN_AS_PATIENT,
            NamedRoutes.LOGIN_SWITCH_ORG_AS_PATIENT,
            NamedRoutes.LOGIN_REDIRECT_TO_EMBED,
            NamedRoutes.PATIENT_CONSENT_ENROLLMENT,
            NamedRoutes.PATIENT_CONSENT_DATA_UPDATE,
            NamedRoutes.PATIENT_IAS_CONSENT,
            NamedRoutes.PATIENT_IAS_DATA_UPDATE,
            NamedRoutes.GUIDED_PATIENT_CONSENT_ENROLLMENT,
            NamedRoutes.PATIENT_HOME_ONBOARDING,
            NamedRoutes.PATIENT_SHARING_DETAILS,
            NamedRoutes.PATIENT_DELETE_MY_ACCOUNT,
            NamedRoutes.PATIENT_ACCOUNT_DELETE_CONFIRMATION,
        ])) {
            return true;
        }
        return false;
    }
    get mobilePageHeight() {
        return this.isHeaderAndFooterFixedRoute ? "100%" : "auto";
    }
    get pageType() {
        const mobileRoutes = [
            NamedRoutes.LOGIN_SELECT,
            NamedRoutes.LOGIN_AS_ORG_USER,
            NamedRoutes.LOGIN_AS_PATIENT,
            NamedRoutes.LOGIN_AS_PATIENT_EMAIL_COLLECTION,
            NamedRoutes.LOGIN_SWITCH_ORG_AS_PATIENT,
            NamedRoutes.LOGIN_REDIRECT_TO_EMBED,
            NamedRoutes.FORGOT_PASSWORD,
            NamedRoutes.RESET_PASSWORD,
            NamedRoutes.EXPIRED_PASSWORD,
            NamedRoutes.PATIENT_SHARING,
            NamedRoutes.PATIENT_SHARING_DETAILS,
            NamedRoutes.PATIENT_CONSENT_ENROLLMENT,
            NamedRoutes.PATIENT_CONSENT_DATA_UPDATE,
            NamedRoutes.PATIENT_IAS_CONSENT,
            NamedRoutes.PATIENT_IAS_DATA_UPDATE,
            NamedRoutes.GUIDED_PATIENT_CONSENT_ENROLLMENT,
            NamedRoutes.PATIENT_HOME_ONBOARDING,
            NamedRoutes.PATIENT_HOME,
            NamedRoutes.PATIENT_MY_HEALTHEX_PROFILE,
            NamedRoutes.SMART_CALLBACK,
            NamedRoutes.SMART_LAUNCH,
            NamedRoutes.ORG_LINK,
            NamedRoutes.CLEAR_IAL2_CALLBACK,
            NamedRoutes.FACILITATED_FHIR_CALLBACK,
            NamedRoutes.FACILITATED_FHIR_OPEN_EPIC_CALLBACK,
            NamedRoutes.FASTEN_CALLBACK,
            NamedRoutes.SOCIAL_LOGIN_CALLBACK,
            NamedRoutes.PATIENT_DELETE_MY_ACCOUNT,
            NamedRoutes.PATIENT_ACCOUNT_DELETE_CONFIRMATION,
            NamedRoutes.PATIENT_CREATE_SMART_LINK,
            NamedRoutes.PATIENT_SMART_LINK_DETAILS,
        ];
        const mobileRoutesForPatient = [
            NamedRoutes.RESEARCH_STUDIES,
            NamedRoutes.LOGIN_SWITCH_ORG_AS_PATIENT,
            NamedRoutes.PATIENT_ACCOUNT_DELETE_CONFIRMATION,
        ];
        if (findMatchingNamedRouteParent(this.routingUIManager.currentRoute, mobileRoutes)) {
            return "MOBILE";
        }
        if (this.authManager.userType === UserType.PATIENT &&
            findMatchingNamedRouteParent(this.routingUIManager.currentRoute, mobileRoutesForPatient)) {
            return "MOBILE";
        }
        return "DESKTOP";
    }
    get showLoginGradient() {
        const loginGradientRoutes = [
            NamedRoutes.LOGIN_AS_ORG_USER,
            NamedRoutes.LOGIN_SWITCH_ORG_AS_PATIENT,
            NamedRoutes.LOGIN_REDIRECT_TO_EMBED,
            NamedRoutes.FORGOT_PASSWORD,
            NamedRoutes.RESET_PASSWORD,
            NamedRoutes.EXPIRED_PASSWORD,
        ];
        return (!!findMatchingNamedRouteParent(this.routingUIManager.currentRoute, loginGradientRoutes) ||
            this.patientConsentUIManager.showClassicLoginPage);
    }
    get showHeaderView() {
        const noHeaderRoutes = [
            NamedRoutes.LOGIN_SWITCH_ORG_AS_PATIENT,
            NamedRoutes.LOGIN_REDIRECT_TO_EMBED,
            NamedRoutes.PATIENT_CONSENT_ENROLLMENT,
            NamedRoutes.PATIENT_CONSENT_DATA_UPDATE,
            NamedRoutes.PATIENT_IAS_CONSENT,
            NamedRoutes.PATIENT_IAS_DATA_UPDATE,
            NamedRoutes.GUIDED_PATIENT_CONSENT_ENROLLMENT,
            NamedRoutes.PATIENT_HOME_ONBOARDING,
            NamedRoutes.PATIENT_MY_HEALTHEX_PROFILE,
            NamedRoutes.PROJECTS_ADD_PROJECT,
        ];
        if (findMatchingNamedRouteParent(this.routingUIManager.currentRoute, noHeaderRoutes)) {
            return false;
        }
        else {
            return true;
        }
    }
    get showFooterView() {
        if (this.authManager.isEmbeddedProvider)
            return false;
        const noFooterRoutes = [
            NamedRoutes.WELCOME,
            NamedRoutes.WELCOME_ORG,
            NamedRoutes.WELCOME_ORG_USER_DETAILS,
            NamedRoutes.WELCOME_BASIC_ORG_DETAILS,
            NamedRoutes.WELCOME_CUSTOMIZE_ORG_DETAILS,
            NamedRoutes.PROJECTS_ADD_PROJECT,
        ];
        return !findMatchingNamedRouteParent(this.routingUIManager.currentRoute, noFooterRoutes);
    }
    get showMobileFooterNavigation() {
        if (this.authManager.isEmbeddedProvider)
            return false;
        const footerNavigationRoutes = [NamedRoutes.PATIENT_SHARING, NamedRoutes.PATIENT_HOME];
        if (footerNavigationRoutes.some((route) => { var _a; return route.routeName === ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName); })) {
            return true;
        }
        else {
            return false;
        }
    }
    updateSearchParams(locationSearch) {
        this.appUIManager.updateSearchParams(locationSearch);
    }
    async onFTUEducationDialogClose() {
        this.ftuEducationDialog.onChoice(true);
        if (this.authManager.orgId === null || this.authManager.id === null)
            return;
        if (this.authManager.userType !== UserType.HEALTHCARE_ORGANIZATION && this.authManager.userType !== UserType.EXTERNAL_RESEARCHER)
            return;
        try {
            await this.organizationsManager.editUser(this.authManager.orgId, this.authManager.id, {
                type: this.authManager.userType,
                onboardingComplete: true,
            });
        }
        catch (e) {
            console.log("Error updating onboardingComplete");
        }
    }
    handleCommonDialogChange() {
        this.commonDialog.open = false;
        this.commonDialogInfo = this.dialogUIManager.dialogInfo;
        if (this.commonDialogInfo) {
            this.commonDialog.show();
        }
    }
    closeCommonDialog() {
        this.commonDialog.open = false;
    }
    get invalidEmbed() {
        return this.authManager.invalidEmbed;
    }
}
__decorate([
    observable
], AppViewModel.prototype, "commonDialogInfo", void 0);
__decorate([
    computed
], AppViewModel.prototype, "isHealthcareOrg", null);
__decorate([
    computed
], AppViewModel.prototype, "ftuEducationDialogDescription", null);
__decorate([
    computed
], AppViewModel.prototype, "orgName", null);
__decorate([
    computed
], AppViewModel.prototype, "isMobilePortraitTouchDevice", null);
__decorate([
    computed
], AppViewModel.prototype, "showDesktopNotEnoughSpaceView", null);
__decorate([
    computed
], AppViewModel.prototype, "desktopNotEnoughSpaceTitle", null);
__decorate([
    computed
], AppViewModel.prototype, "desktopNotEnoughSpaceText", null);
__decorate([
    computed
], AppViewModel.prototype, "banner", null);
__decorate([
    computed
], AppViewModel.prototype, "needsAcceptInvite", null);
__decorate([
    computed
], AppViewModel.prototype, "showHeaderAndFooter", null);
__decorate([
    computed
], AppViewModel.prototype, "currentPage", null);
__decorate([
    computed
], AppViewModel.prototype, "isHeaderAndFooterFixedRoute", null);
__decorate([
    computed
], AppViewModel.prototype, "mobilePageHeight", null);
__decorate([
    computed
], AppViewModel.prototype, "pageType", null);
__decorate([
    computed
], AppViewModel.prototype, "showLoginGradient", null);
__decorate([
    computed
], AppViewModel.prototype, "showHeaderView", null);
__decorate([
    computed
], AppViewModel.prototype, "showFooterView", null);
__decorate([
    computed
], AppViewModel.prototype, "showMobileFooterNavigation", null);
__decorate([
    computed
], AppViewModel.prototype, "invalidEmbed", null);
